"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDropDownCloud = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M51.52 23.14l2.89-3.67h-5.77l2.88 3.67z"
  }), _react["default"].createElement("path", {
    d: "M58.37 28.64v-15.8H4.83v15.8h53.54zM47 15.47h8.78V26H47zM44.33 26H7.46V15.47h36.87zM64.71 43.83a9.61 9.61 0 0 0-3.41-6.33v-5.79H19.17v9.07H41.6a5.34 5.34 0 0 0-.69 1.47H19.17v9.07h18a7.27 7.27 0 0 0 .39 1.39H19.17v9.07H61.3v-4.41h1.17a6.93 6.93 0 0 0 6.92-6.92 7.09 7.09 0 0 0-4.68-6.62zM21.8 38.15v-3.8h36.86v1.6a9.25 9.25 0 0 0-3.33-.62 9.74 9.74 0 0 0-6.81 2.82zm15.42 10.53H21.8v-3.8h17.32a8 8 0 0 0-1.9 3.8zm21.44 10.46H21.8v-3.8h17.57a7.31 7.31 0 0 0 5.05 2h14.24zm-1.46-3.55zm5.27-.73h-18A4.83 4.83 0 0 1 39.59 50a5.33 5.33 0 0 1 2.88-4.6l.71-.34v-1.28A2.86 2.86 0 0 1 46 40.92a3.37 3.37 0 0 1 .45 0l.38.08a3.42 3.42 0 0 1 .43.18l.28.16a2.84 2.84 0 0 1 1.31 2.39 1.26 1.26 0 0 0 2.51 0A5.35 5.35 0 0 0 50 40.2a7.36 7.36 0 0 1 5.3-2.35 7 7 0 0 1 6.76 5.62 9.57 9.57 0 0 0-1.34.1A1.26 1.26 0 0 0 59.7 45a1.26 1.26 0 0 0 1.24 1.07h.19a8.68 8.68 0 0 1 2.16 0 4.51 4.51 0 0 1 3.59 4.4 4.41 4.41 0 0 1-4.41 4.38z"
  })),
  height: undefined,
  width: undefined
});
IconDropDownCloud.displayName = 'IconDropDownCloud';
var _default = IconDropDownCloud;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/drop-down-cloud.js
// module id = 568
// module chunks = 0